import { useEffect, useState } from 'react';
import {
  Modal,
  ModalBody,
  UnorderedList,
  ListItem,
  Button,
  Link,
} from 'carbon-components-react';
import { ArrowRight16, Restart16 } from '@carbon/icons-react';
import Thanks from '../../Molecules/Thanks/Thanks';
import * as URX_FORM from '../../../constants/urx-form';
import { swapCountryAndLanguage } from 'src/common/utils/swapCountryAndLanguage';
import { IBMLocale } from 'src/common/locale/mapValidLocale';
import { initUrxForm } from 'src/common/hooks/widgets/urxForm';
import { useEnv } from 'src/common/hooks/widgets/useEnv';
import messages from '../../../locales/messages';
import { FormattedMessage } from 'react-intl';
import { segmentTracking } from '../../../lib/tracker';
import { FormModal } from 'src/common/utils/FormModal';
import './Ending.scss';
import '../../../../../common/style/common.scss';
import PublicImage from 'src/common/components/PublicImage';
import {
  adoption_limit,
  discovery_limit,
  experimentation_limit,
} from 'src/apps/watsonx-orchestrate-self-assessment/constants/default';
export {
  adoption_limit,
  experimentation_limit,
  discovery_limit,
} from '../../../constants/default';

import Cookies from 'js-cookie';
import { useCookiesURL } from 'src/common/hooks/widgets/useCookiesURL';

type EndingProps = {
  langCode: string;
  bpName: string;
  logo: string;
  companyId: string;
  totalPoints: number;
  selectedPath: string;
  reset1: () => void;
  reset2: () => void;
  cookieContent: string;
};

export const Ending = ({
  langCode,
  bpName,
  logo,
  companyId,
  totalPoints,
  selectedPath,
  reset1,
  reset2,
  cookieContent,
}: EndingProps) => {
  const [environment] = useEnv();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [formComplete, setFormComplete] = useState(false);
  const localeCode = swapCountryAndLanguage(langCode as IBMLocale);
  const [openEndingModal, setOpenEndingModal] = useState(true);
  const [, setOpenUrxModal] = useState(false);
  const pictureDiscovery = 'images/Discovery_Icon.svg';
  const pictureExperimentation = 'images/Experiment_Icon.svg';
  const pictureAdoption = 'images/Adoption_Icon.svg';
  const [, setBpConsentMail] = useState(false);
  const cookieURL = useCookiesURL();
  const [demo, setDemo] = useState('');
  const [urxForm, setURXForm] = useState('');
  window.urxEnvironment = environment;
  window.onUrxFormSubmitSuccess = () => {
    setFormComplete(!formComplete);
    setDrawerOpen(false);
  };

  const handleReset = () => {
    segmentTracking('CTA Clicked', {
      pageTitle: 'Watsonx Orchestrate SA',
      object: 'Watsonx Orchestrate SA page',
      resultValue: 'CTA clicked',
      CTA: 'Start Over',
      location: `${selectedPath} Path Selection`,
      action: '',
      field: '',
    });
    reset1();
  };

  useEffect(() => {
    if (!drawerOpen && !openEndingModal && !formComplete) {
      setOpenEndingModal(true);
    }
    if (totalPoints < experimentation_limit) {
      setURXForm(URX_FORM.FORM_ID);
      setDemo(
        'https://watsonx-orchestrate-demo.17f48735.public.multi-containers.ibm.com',
      );
    } else {
      setURXForm(URX_FORM.FORM_ID1);
      setDemo('');
    }
  }, [drawerOpen, totalPoints]);

  const watchDemo = () => {
    const url =
      selectedPath === 'Non-Tech'
        ? 'https://mediacenter.ibm.com/media/1_7ymbs3hf'
        : 'https://mediacenter.ibm.com/media/1_jgfumwcm';
    segmentTracking('CTA Clicked', {
      pageTitle: 'Watsonx Orchestrate SA',
      object: 'Watsonx Orchestrate SA - Discovery',
      resultValue: 'CTA clicked',
      CTA: 'Watch these Demo videos CTA',
      location: `${selectedPath} Path Selection`,
      action: `Form modal closed`,
      field: '',
    });
    setTimeout(async () => {
      window.open(url);
    }, 250);
  };

  const orchestrateIntegrations = () => {
    const url = 'https://www.ibm.com/products/watsonx-orchestrate/integrations';
    segmentTracking('CTA Clicked', {
      pageTitle: 'Watsonx Orchestrate SA',
      object: 'Watsonx Orchestrate SA - Experimentation',
      resultValue: 'CTA clicked',
      CTA: 'Explore watsonx Orhcestrate integrations CTA',
      location: `${selectedPath} Path Selection`,
      action: `Form modal closed`,
      field: '',
    });
    setTimeout(async () => {
      window.open(url);
    }, 250);
  };

  const watsonxOrchestrate = () => {
    const url = 'https://www.ibm.com/products/watsonx-orchestrate/resources';
    segmentTracking('CTA Clicked', {
      pageTitle: 'Watsonx Orchestrate SA',
      object: 'Watsonx Orchestrate SA - Experimentation',
      resultValue: 'CTA clicked',
      CTA: 'Learn how others are using watsonx Orhcestrate CTA',
      location: `${selectedPath} Path Selection`,
      action: `Form modal closed`,
      field: '',
    });
    setTimeout(async () => {
      window.open(url);
    }, 250);
  };

  const partnerProgram = () => {
    const url = 'https://www.ibm.com/products/watsonx-orchestrate/partners';
    segmentTracking('CTA Clicked', {
      pageTitle: 'Watsonx Orchestrate SA',
      object: 'Watsonx Orchestrate SA - Adoption',
      resultValue: 'CTA clicked',
      CTA: 'Join our IBM Partner Program CTA',
      location: `${selectedPath} Path Selection`,
      action: `Form modal closed`,
      field: '',
    });
    setTimeout(async () => {
      window.open(url);
    }, 250);
  };

  const automationCommunity = () => {
    const url =
      'https://community.ibm.com/community/user/automation/communities/community-home?CommunityKey=3ad46381-9535-462e-85c9-568b21f4b067&';
    segmentTracking('CTA Clicked', {
      pageTitle: 'Watsonx Orchestrate SA',
      object: 'Watsonx Orchestrate SA - Adoption',
      resultValue: 'CTA clicked',
      CTA: 'Join our Automation Community CTA',
      location: `${selectedPath} Path Selection`,
      action: `Form modal closed`,
      field: '',
    });
    setTimeout(async () => {
      window.open(url);
    }, 250);
  };

  const setCookie = (formId: string) => {
    const mailCheckbox =
      document.querySelector<HTMLInputElement>('#Q_MAIL_CONSENT');
    setBpConsentMail(!!mailCheckbox?.checked); // set false if unchecked or if undefined
    Cookies.set(
      'urxdcq',
      JSON.stringify({
        source: formId,
        // One field to provide all values (stringify)
        dcq: {
          Q_NOTESDATA:
            cookieURL +
            cookieContent +
            ' | CTA -Watsonx Orchestrate Self Assessment-' +
            ' | FormId:' +
            formId,
          Q_ASSET_NAME: 'Watsonx Orchestrate Self Assessment', // ISC - Asset Name
        },
      }),
    );
  };

  return (
    <div className="bx--grid watsonxsa_widget">
      <div className="Ending">
        <Modal
          passiveModal={true}
          open={openEndingModal}
          size={'lg'}
          onRequestClose={() => {
            segmentTracking('CTA Clicked', {
              pageTitle: 'Watsonx Orchestrate SA',
              object: 'Watsonx Orchestrate SA',
              resultValue: 'CTA clicked',
              CTA: 'Form modal closed on the corner',
              location: `${selectedPath} Path Selection`,
              action: `Form modal closed`,
              field: '',
            });
            reset2();
          }}
        >
          <ModalBody hasForm className="ModalBody">
            <div className="watsonxsa_widget">
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-16 bx--col-sm-16">
                  <span className="page_sub_heading">
                    <FormattedMessage {...messages.page_title} />
                  </span>
                </div>
                <div className="bx--col-lg-3 bx--col-md-8 bx--col-sm-4">
                  <Link
                    role="button"
                    id="reset-id1"
                    className="reset-item bx-link-class-restart"
                    rel="noreferrer"
                    onClick={handleReset}
                  >
                    <FormattedMessage {...messages.start_over} />
                    <Restart16 className="restart-icon" />
                  </Link>
                </div>
              </div>
              {totalPoints <= discovery_limit && (
                <div>
                  <div className="bx--row nam">
                    <div className="bx--col-lg-11 bx--col-md-5 bx--col-sm-3">
                      <div className="bx-row EndingDiv1">
                        <div className="page_heading type1">
                          <FormattedMessage
                            {...messages.EndingDiscoveryTitle}
                          />
                        </div>
                        <div className="page_body">
                          <p className="page_body">
                            <FormattedMessage
                              {...messages.EndingDiscoveryText1}
                            />
                          </p>
                          <br />
                          <p className="page_body mar-small">
                            <FormattedMessage
                              {...messages.EndingDiscoveryText2}
                            />
                          </p>
                          <br />
                          <p className="page_body mar-small">
                            <FormattedMessage
                              {...messages.EndingDiscoveryText3}
                            />
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="bx--col-lg-5 bx--col-md-3 bx--col-sm-3">
                      <div className="bx--row mar-top">
                        <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                          <PublicImage
                            imgPath={pictureDiscovery}
                            widgetId="watsonx-orchestrate-self-assessment"
                            id="img1"
                            alt="Watsonx Orchestrate SA Discovery picture"
                          />
                        </div>
                      </div>
                      <div className="bx--row mar-top-2">
                        <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                          <span className="slide_text">
                            <FormattedMessage {...messages.EndingListTitle1} />
                          </span>
                          <br />
                          <span className="slide_text">
                            <FormattedMessage {...messages.EndingListTitle2} />
                          </span>
                        </div>
                      </div>
                      <div className="bx--row mar-top-1">
                        <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                          <Link
                            role="button"
                            id="watch-demo-id"
                            className="bx-link-class"
                            rel="noreferrer"
                            onClick={() => {
                              watchDemo();
                            }}
                          >
                            <FormattedMessage
                              {...messages.EndingDiscoveryListLink1}
                            />
                            {'  '}
                            <ArrowRight16 className="Image" />
                          </Link>
                        </div>
                      </div>
                      <div className="bx--row mar-top-2">
                        <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                          <span className="slide_text">
                            <FormattedMessage {...messages.EndingListTitle3} />
                          </span>
                        </div>
                      </div>
                      <div className="bx--row mar-top-1">
                        <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                          <Link
                            role="button"
                            className="bx-link-class"
                            id="urx-link-id"
                            rel="noreferrer"
                            onClick={() => {
                              segmentTracking('CTA Clicked', {
                                pageTitle: 'Watsonx Orchestrate SA',
                                object: 'Watsonx Orchestrate SA - Discovery',
                                resultValue: 'CTA clicked',
                                CTA: 'Take our Interactive demo CTA',
                                location: `${selectedPath} Path Selection`,
                                action: `Form modal closed`,
                                field: '',
                              });
                              setOpenUrxModal(true);
                              setDrawerOpen(true);
                              setOpenEndingModal(false);
                              initUrxForm(
                                environment,
                                URX_FORM.INSTANCE_ID,
                                urxForm,
                                localeCode as IBMLocale,
                                companyId,
                              );
                              setCookie(urxForm);
                            }}
                          >
                            <FormattedMessage
                              {...messages.EndingDiscoveryListLink2}
                            />
                            {'  '}
                            <ArrowRight16 className="Image" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {totalPoints > discovery_limit &&
                totalPoints < experimentation_limit && (
                  <div>
                    <div className="bx--row nam">
                      <div className="bx--col-lg-11 bx--col-md-5 bx--col-sm-3">
                        <div className="bx-row EndingDiv2">
                          <div className="page_heading type1">
                            <FormattedMessage
                              {...messages.EndingExperimentationTitle}
                            />
                          </div>
                          <div>
                            <p className="page_body">
                              <FormattedMessage
                                {...messages.EndingExperimentationText1}
                              />
                            </p>
                            <br />
                            <p className="page_body mar-small">
                              <FormattedMessage
                                {...messages.EndingExperimentationText2}
                              />
                            </p>
                            <UnorderedList>
                              <ListItem>
                                <p className="page_body">
                                  <FormattedMessage
                                    {...messages.EndingExperimentationText3}
                                  />
                                </p>
                              </ListItem>
                              <ListItem>
                                <p className="page_body">
                                  <FormattedMessage
                                    {...messages.EndingExperimentationText4}
                                  />
                                </p>
                              </ListItem>
                              <ListItem>
                                <p className="page_body">
                                  <FormattedMessage
                                    {...messages.EndingExperimentationText5}
                                  />
                                </p>
                              </ListItem>
                            </UnorderedList>
                            <br />
                            <p className="page_body mar-small">
                              <FormattedMessage
                                {...messages.EndingExperimentationText6}
                              />
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="bx--col-lg-5 bx--col-md-3 bx--col-sm-3">
                        <div className="bx--row mar-top">
                          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                            <PublicImage
                              imgPath={pictureExperimentation}
                              widgetId="watsonx-orchestrate-self-assessment"
                              id="img1"
                              alt="Watsonx Orchestrate SA Expreimentation picture "
                            />
                          </div>
                        </div>
                        <div className="bx--row mar-top-2">
                          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                            <span className="slide_text">
                              <FormattedMessage
                                {...messages.EndingListTitle1}
                              />
                            </span>
                            <br />
                            <span className="slide_text">
                              <FormattedMessage
                                {...messages.EndingListTitle2}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="bx--row mar-top-1">
                          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                            <Link
                              role="button"
                              className="bx-link-class"
                              id="orchestrate-integration-id"
                              rel="noreferrer"
                              onClick={() => {
                                orchestrateIntegrations();
                              }}
                            >
                              <FormattedMessage
                                {...messages.EndingExperimentationListLink1}
                              />
                              <ArrowRight16 />
                            </Link>
                          </div>
                        </div>
                        <div className="bx--row mar-top-1">
                          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                            <Link
                              role="button"
                              className="bx-link-class"
                              id="using-orchestration-id"
                              rel="noreferrer"
                              onClick={() => {
                                watsonxOrchestrate();
                              }}
                            >
                              <FormattedMessage
                                {...messages.EndingExperimentationListLink2}
                              />
                              <ArrowRight16 />
                            </Link>
                          </div>
                        </div>
                        <div className="bx--row mar-top-2">
                          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                            <span className="slide_text">
                              <FormattedMessage
                                {...messages.EndingListTitle3}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="bx--row mar-top-1">
                          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                            <Link
                              role="button"
                              className="bx-link-class"
                              id="interactive-tour-id"
                              rel="noreferrer"
                              onClick={() => {
                                segmentTracking('CTA Clicked', {
                                  pageTitle: 'Watsonx Orchestrate SA',
                                  object:
                                    'Watsonx Orchestrate SA - Experimentation',
                                  resultValue: 'CTA clicked',
                                  CTA: 'Take our Interactive demo CTA',
                                  location: `${selectedPath} Path Selection`,
                                  action: `Form modal closed`,
                                  field: '',
                                });
                                setOpenUrxModal(true);
                                setDrawerOpen(true);
                                setOpenEndingModal(false);
                                initUrxForm(
                                  environment,
                                  URX_FORM.INSTANCE_ID,
                                  urxForm,
                                  localeCode as IBMLocale,
                                  companyId,
                                );
                                setCookie(urxForm);
                              }}
                            >
                              <FormattedMessage
                                {...messages.EndingExperimentationListLink3}
                              />
                              {'  '}
                              <ArrowRight16 />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {totalPoints >= experimentation_limit &&
                totalPoints < adoption_limit && (
                  <div>
                    <div className="bx--row nam">
                      <div className="bx--col-lg-11 bx--col-md-5 bx--col-sm-3">
                        <div className="bx-row EndingDiv3">
                          <div className="page_heading type1">
                            <FormattedMessage
                              {...messages.EndingAdoptionTitle}
                            />
                          </div>
                          <div className="page_body">
                            <p className="page_body">
                              <FormattedMessage
                                {...messages.EndingAdoptionText1}
                              />
                            </p>
                            <br />
                            <p className="page_body mar-small">
                              <FormattedMessage
                                {...messages.EndingAdoptionText2}
                              />
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="bx--col-lg-5 bx--col-md-3 bx--col-sm-3">
                        <div className="bx--row mar-top">
                          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                            <PublicImage
                              imgPath={pictureAdoption}
                              widgetId="watsonx-orchestrate-self-assessment"
                              id="img1"
                              alt="Watsonx Orchestrate SA Adoption picture "
                            />
                          </div>
                        </div>
                        <div className="bx--row mar-top-2">
                          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                            <span className="slide_text">
                              <FormattedMessage
                                {...messages.EndingListTitle1}
                              />
                            </span>
                            <br />
                            <span className="slide_text">
                              <FormattedMessage
                                {...messages.EndingListTitle2}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="bx--row mar-top-1">
                          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                            <Link
                              role="button"
                              className="bx-link-class"
                              id="partner-program-id"
                              rel="noreferrer"
                              onClick={() => {
                                partnerProgram();
                              }}
                            >
                              <FormattedMessage
                                {...messages.EndingAdoptionListLink1}
                              />
                              {'  '}
                              <ArrowRight16 />
                            </Link>
                          </div>
                        </div>
                        <div className="bx--row mar-top-1">
                          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                            <Link
                              role="button"
                              className="bx-link-class"
                              id="automation-community-id"
                              rel="noreferrer"
                              onClick={() => {
                                automationCommunity();
                              }}
                            >
                              <FormattedMessage
                                {...messages.EndingAdoptionListLink2}
                              />
                              {'  '}
                              <ArrowRight16 />
                            </Link>
                          </div>
                        </div>
                        <div className="bx--row mar-top-2">
                          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                            <span className="slide_text">
                              <FormattedMessage
                                {...messages.EndingListTitle3}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="bx--row mar-top-1">
                          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                            <Link
                              role="button"
                              className="bx-link-class"
                              id="Live-demo-id"
                              rel="noreferrer"
                              onClick={() => {
                                segmentTracking('CTA Clicked', {
                                  pageTitle: 'Watsonx Orchestrate SA',
                                  object: 'Watsonx Orchestrate SA - Adoption',
                                  resultValue: 'CTA clicked',
                                  CTA: 'Book a live demo with an IBM expert CTA',
                                  location: `${selectedPath} Path Selection`,
                                  action: `Form modal closed`,
                                  field: '',
                                });
                                setOpenUrxModal(true);
                                setDrawerOpen(true);
                                setOpenEndingModal(false);
                                initUrxForm(
                                  environment,
                                  URX_FORM.INSTANCE_ID,
                                  urxForm,
                                  localeCode as IBMLocale,
                                  companyId,
                                );
                                setCookie(urxForm);
                              }}
                            >
                              <FormattedMessage
                                {...messages.EndingAdoptionListLink3}
                              />
                              {'  '}
                              <ArrowRight16 />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </ModalBody>
        </Modal>
        <FormModal
          pageTitle="Watsonx Orchestrate SA"
          object="Watsonx Orchestrate SA Page"
          productTitle={'Watsonx Orchestrate SA'}
          pageUrl={''}
          location={'Assessment'}
          bpName={bpName}
          logo={logo}
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen}
        ></FormModal>
        {formComplete && <Thanks bpName={bpName} demo={demo} />}
      </div>
    </div>
  );
};
